import { Instagram } from '@ionic-native/instagram';
import { NodeToImgService } from './../../../providers/nodetoimg.service';
import { Component, ViewChild } from '@angular/core';
import { TranslateService, TranslateFakeCompiler } from '@ngx-translate/core';
import { App, NavController, NavParams, ToastController, ModalController, Thumbnail, Platform } from 'ionic-angular';
import { TrophyComponent } from '../../../components/trophy/trophy';
import { LoaderProvider } from '../../../providers/loader/loader';
import { RanglistSearchModel, ResultListModel, ResultProvider } from '../../../providers/result/result';
import { SharingProvider } from '../../../providers/sharing/sharing';
import { PublicProfileModel, UserProvider, MySportProfileListItem, PrivateProfile } from '../../../providers/user/user';
import { ValueProvider } from '../../../providers/value/value';
import { ResultProfilePage } from '../result-profile/result-profile';
import { ResultRanglistPage } from '../result-ranglist/result-ranglist';
import { MysportResultsMenuPage } from '../../me/mysport/mysport-results/mysport-results-menu/mysport-relults-menu';
import { MysportContactsPage } from '../../me/mysport/mysport-contacts/mysport-contacts';
import { ConfigProvider } from '../../../providers/config/config';
import { ResultDetailsTabsPage } from '../result-details/result-details-tabs/result-details-tabs';
import { SessionProvider } from '../../../providers/session/session';
import { LoginPage } from '../../login/login/login';
import { ResultDetailsCommentPage } from './result-details-comment/result-details-comment';
import { ResultDetailsThumbupPage } from './result-details-thumbup/result-details-thumbup';
import { ThrowStmt } from '@angular/compiler';
import { EventTabsPage } from '../../event/details/event-tabs/event-tabs';
import { EventDetailsModel, EventProvider } from '../../../providers/event/event';
import { NewsController } from '../../../providers/news/news-contoller';
import { GpsTracker } from '../../../tracker/gps-tracker';
import { GlobalUtil } from '../../../tracker/global-utils';
import { SocialSharing } from '@ionic-native/social-sharing';
import { File } from '@ionic-native/file';
import * as base64js from 'base64-js';
import { PhotoLibrary } from '@ionic-native/photo-library';
import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
import { PictureElements } from '../../me/mysport/mysport-results/mysport-results-menu/take-selfie/take-selfie';
import { eventCategories } from '../../../assets/data/categories/categories';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { SettingsProvider } from '../../../providers/settings/settings';
import { ActivityFriendsPage, FeedResponse } from '../../event/event-activity-tabs/activity-friends/activity-friends';
import { ExternalFeedsPage } from '../../event/event-activity-tabs/external-feeds-page/external-feeds-page';

/**
 * Generated class for the ResoultMainPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
declare var cordova;

@Component({
  selector: 'page-result-details',
  templateUrl: 'result-details.html'
})
export class ResultDetailsPage {
  feeds:FeedResponse[] = [];
  result: ResultListModel | any;
  profile: PrivateProfile;

  toolbar: boolean = false;
  buttonProfile: boolean = false;

  comments: any;
  congrats: any;

  init: boolean = false;
  userSection: boolean = false;
  userLid: number = null;
  userId:number = null;
  imageWidth: number = innerWidth * 0.9;
  imageHeight: number = innerHeight * 0.65;
  // 93px is the margin-top + margin-bottom 
  // imageWidth = (document.getElementsByClassName('scroll-content')[0] as HTMLElement | null).offsetWidth;
  // imageHeight = (document.getElementsByClassName('scroll-content')[0] as HTMLElement | null).offsetHeight - 93;

  imageUrl = "assets/imgs/goforest/forest.jpg";
  preparedImage;
  resultDetails: PictureElements = null;
  canvasStats;
  pipeDateFormat = "dd.MM.yyyy";
  paginator = {
    page: null,
    start: null,
    limit: null
    }

  @ViewChild('trophy')
  trophyComponent: TrophyComponent;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public app: App,
    public translate: TranslateService,
    private loadingCtrl: LoaderProvider,
    private resultService: ResultProvider,
    private userService: UserProvider,
    public sharingService: SharingProvider,
    private toastCtrl: ToastController,
    public valueService: ValueProvider,
    private modalCtrl: ModalController,
    private sharer: SocialSharing,
    private config: ConfigProvider,
    private file: File,
    private photoLibrary: PhotoLibrary,
    private sessionService: SessionProvider,
    private resultProvider: ResultProvider,
    private userProvider: UserProvider,
    private eventService: EventProvider,
    private iab: InAppBrowser,
    private nodeToImage: NodeToImgService,
    private socialSharing: SocialSharing,
    private platform: Platform,
    private settingsService: SettingsProvider,
    private instagram: Instagram
  ) {
    new Promise(async (resolve, reject) => {
      this.userSection = navParams.get('userSection');
      this.result = navParams.get('result');
      this.userLid = navParams.get('userLid');
      this.userId = this.result.id || this.result.athleteId
      console.log('this.userid', this.userId)
      this.settingsService.getActiveDateFormat().then(date => {
        this.pipeDateFormat = date.pipeFormat;
      });
      GlobalUtil.getInstance().currentEventID = this.result.eventId;

      if (this.userSection) {
        // this.result.eventName = (this.result.eventName.toLocaleUpperCase() == "MARATHON") ? "Mitarbeiter Deutsche Post DHL Group" : this.result.eventName;
        this.result.eventName = "Mitarbeiter Deutsche Post DHL Group";
      }
      this.toolbar = (await this.config.config).showHide.tabsToolbar;
      this.buttonProfile = (await this.config.config).showHide.buttonProfile;
    });
  }

  async onTabs(i) {
    await this.sessionService.getToken(false, false)
    if (this.sessionService.isLoged)
      this.app.getRootNav().push(ResultDetailsTabsPage, { result: this.result });
  }

  // addFan() {
  //   this.resultProvider.congrat(this.result.id);
  // }

  // removeFan() {
  //   this.resultProvider.removeCongrat(this.result.id).then(data => {
  //     this.getCongrats();
  //   })
  // }

  onPageLoad(str) {
    let page = (str.includes('comment')) ? ResultDetailsCommentPage : ResultDetailsThumbupPage;

    this.sessionService.getLoginStatus().then(status => {
      if (status) this.navCtrl.push(page, { result: this.result });
      else {
        new Promise((resolve, reject) => {
          this.app.getRootNav().push(LoginPage, { resolve: resolve })
        }).then((status) => {
          if (status) this.navCtrl.push(page, { result: this.result });
        });
      }
    });
  }

  showRangPage() {
    let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();

    let resultSeach = {
      eid: this.result.eventId + '',
      ename: '' + this.result.eventName,
      limit: null,
      page: null,
      start: null
    } as RanglistSearchModel;
    this.resultService.getRangList(resultSeach).then(items => {
      console.log(items);
      (this.app.getRootNav() as NavController).push(ResultRanglistPage, { data: { list: items, search: resultSeach } }).then(() => loader.dismiss());
    });
  }

  showSportProfile() {
    // let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    // loader.present();

    // this.valueService.getProfileBackgrounds().then(backgrounds => {
    //   this.userService.getPublicProfile(this.result.athleteId).then((value: PublicProfileModel) => {
    //     (this.app.getRootNav() as NavController)
    //       .push(ResultProfilePage, { profile: value, backgrounds: backgrounds, result: this.result })
    //       .then(() => loader.dismiss());
    //   });
    // });
  }

  preloadData() {
    // comments and congrats numbers preload
    let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();

    Promise.all([this.getComments(), this.getCongrats()]).then(() => {
      this.reload();
      loader.dismiss()
    });
  }

  reload() {
    this.init = false;
    setTimeout(() => {
      this.init = true
    });
  }

  getComments(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.resultProvider.getComments(this.result.id, null, null, null).then(data => {
        this.comments = data;
        console.log('data: ', data);
        resolve(data);
      });
    });
  }

  getCongrats(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      console.log(this.result)
      this.resultProvider.getFans(this.result.id, null, null, null).then(data => {
        this.congrats = data;
        resolve(data);
      });
    });
  }

  getEventImages() {
    return new Promise((resolve, reject) => {
      this.eventService.getEventDetailsById(this.result.eventId).then(eventDetails => {
        if (!eventDetails) {
          alert('No event details found.');
          reject();
          return;
        }
        resolve(eventDetails.images)
      })
    });
  }
  shareFacebook() {
    this.applyResultsForFirstEventPicture().then((image: any) => {
      this.sharingService.shareFacebook('', image);
    });
  }
  shareInstagram() {
    this.applyResultsForFirstEventPicture().then((image: any) => {
      // this.photoLibrary.requestAuthorization({read: true, write: true}).then(() => {
      // console.log('inside');
      // this.photoLibrary.saveImage(image, 'Instagram').then(entry => {
      this.instagram.isInstalled().then(isInstalled => {
        if (!isInstalled) {
          alert("Instagram is not installed on your phone!");
          return;
        }
        this.sharer.shareViaInstagram("", image).then(() => {
          console.log('The image is shared via Instagram!');
        }).catch(err => {
          console.log(err);
          console.log('The image was not shared via Instagram!');
        });
      });
      // }).catch(err => {
      //   console.log(err);
      //   console.log('The image was not saved!');
      // });
      // });
    });
  }

  applyResultsForFirstEventPicture() {
    return new Promise((resolve, reject) => {
      const categoryIndex = eventCategories.findIndex(c => c.id == this.result.cid);
      let category = "";
      if (categoryIndex > -1) {
        category = eventCategories[categoryIndex].name;
      }

      let eventDate = (this.translate.getDefaultLang().toUpperCase().includes("DE"))
        ? new Date(this.result.eventDate).toISOString().substr(0, 10).split('-').reverse().join('.')
        : new Date(this.result.eventDate).toISOString().substr(0, 10);

      let resultDetails = {
        distance: this.result.streckeconv,
        time: new Date(this.result.gtime * 1000).toISOString().substr(11, 8),
        place: this.result.gplatz + ". " + this.translate.instant("RESULT_CREATE_LABEL_PLACE"),
        eventDate: eventDate,
        eventName: this.result.eventName,
        cid: category,
        logo: "assets/imgs/goforest/white.png"
      }
      this.getEventImages().then((images: any) => {
        if (!images.length) {
          images.push({
            imageLink: "https://spooorts.de/resources/images/title8.jpg"
          });
        }
        console.log(images);
        const imageUrl = images[0].imageLink;
        let canvas = <HTMLCanvasElement>document.getElementById("myHiddenCanvas");
        let context = canvas.getContext("2d");

        let img = new Image();
        img.crossOrigin = "anonymous";
        img.src = imageUrl;
        let that = this;
        img.onload = function (e) {
          canvas.height = img.height;
          canvas.width = img.width;
          context.drawImage(img, 0, 0, img.width, img.height);
          let canvasStats = <HTMLCanvasElement>document.getElementById("myHiddenCanvas");
          let contextStats = canvasStats.getContext("2d");
          let logo = new Image();
          logo.src = "assets/imgs/goforest/white.png";
          logo.onload = function () {
            that.sharingService.generateImage(resultDetails, { context, contextStats }, that, img, canvasStats,
              logo).then((image) => {
                resolve(image)
              })
          }
          context.fillStyle = 'rgba(0, 0, 0, 0.5)';
          context.fillRect(0, 0, img.width, img.height);
          context.restore();
        }
      });
    });
  }
  openEventDetails() {
    let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();

    this.eventService.getEventDetails(this.result.eventId).then((event: EventDetailsModel) => {

      if (event.name.length < 1) {
        this.openEventDetails();
        loader.dismiss();
      } else {
        (this.app.getRootNav() as NavController).push(EventTabsPage, { event: event }).then(() => loader.dismiss());
      }
    });
  }

  // congrat() {
  //   let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
  //   loader.present();
  //   this.resultService.congrat(this.result.id).then(succ => {
  //     if (succ) {
  //       this.toastCtrl
  //         .create({
  //           message: 'Congratulation successfull',
  //           duration: 3000,
  //           showCloseButton: true
  //         })
  //         .present();
  //     } else {
  //       this.toastCtrl
  //         .create({
  //           message: 'Unknown problem',
  //           duration: 3000,
  //           showCloseButton: true
  //         })
  //         .present();
  //     }
  //     loader.dismiss();
  //   });
  // }

  showMenu() {
    console.log('show menu');
    const modal = this.modalCtrl.create(MysportResultsMenuPage, { mode: 'public' });
    modal.onDidDismiss(option => {
      console.log("onDidDismiss " + option);
      this.modalPerform(option);
    })
    modal.present();
  }

  // TODO: enum
  modalPerform(option: string) {
    if (option == "add_friend") {
      this.addFriendLoginGuard();
    } else if (option == "fb_post") {
      this.shareFacebook();
    } else if (option == "instagram_post") {
      this.shareInstagram();
    } else if (option == "congrat") {
      this.onPageLoad('thumb');
    } else if (option == "comment") {
      this.onPageLoad('comment');
    } else if (option == "view_profile") {
      //Profil Ansehen 
      this.showSportProfile();
    } else if (option == "finisher_shirt") {
      //redirect to the spooorts shop only if it's spooorts app
      this.shopRedirect();
    } else if (option == "show_trophy") {
      const url = `https://spooorts.de/ui/showTrophy.jsf?id=${this.result.id}`;
      let browser = this.iab.create(url, "_system", { hardwareback: 'yes' });
      browser.show();
    } else if (option == "show_award_ceremondy") {
      const url = `https://spooorts.de/ui/showTrophyPremier.jsf?id=${this.result.id}`;
      let browser = this.iab.create(url, "_system", { hardwareback: 'yes' });
      browser.show();
    }
    else if (option == 'open_feed') {
      this.onOpenActivityFriensPage();
      console.log('redirecting to activityFriensPage')
    }
  }

  onOpenActivityFriensPage() {
    console.log('this.userId', this.userLid)
    this.eventService.getFeeds(this.paginator,this.userLid).then((feeds) => {
      this.feeds = feeds;
      console.log('feeds',feeds)
      this.navCtrl.push(ExternalFeedsPage, { feeds: feeds })
    })
    // this.navCtrl.push(ActivityFriendsPage, {result: this.result})
    console.log('redirecting to activityFriensPage')
  }

  shopRedirect() {
    window.location.href = "http://spooorts.shop";
  }

  addFriendLoginGuard() {
    if(!this.sessionService.isLoged){
      new Promise((resolve, reject) => {
        this.navCtrl.push(LoginPage, { resolve: resolve, isRootNav: false });
      }).then((isLoged: boolean) => {
        if(isLoged){
          this.addFriend();
        }
      });
    }else{
      this.addFriend();
    }
  }

  addFriend() {
    var loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();
    this.userService.addFriend(this.userLid).then(friendList => {
      this.getCongrats().then(fanList => {
        this.navCtrl.push(MysportContactsPage, { friendList: friendList, fanList: fanList }).then(() => loader.dismiss());
      });
    });
  }

  getPrivateProfile(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.userProvider.getPrivateProfile().then(profile => {
        this.profile = profile;
        resolve(true);
      }).catch(err => {
        console.log('err: ', err);
        resolve(false);
      });
    });
  }

  ionViewWillLeave() {
    NewsController.getInstance().isAllowed = true;
    console.log('ionViewWillLeave()')

    // this.trophyComponent.ionViewWillLeave();
  }

  ionViewWillEnter() {
    console.log("ionViewWillEnter()")

    this.trophyComponent.ngAfterViewInit();

    this.preloadData();
  }
}



// WEBPACK FOOTER //
// /src/pages/results/result-details/result-details.ts